import { render } from "./employee-detail.vue?vue&type=template&id=cc458fac&scoped=true"
import script from "./employee-detail.vue?vue&type=script&lang=js"
export * from "./employee-detail.vue?vue&type=script&lang=js"

import "./employee-detail.vue?vue&type=style&index=0&id=cc458fac&lang=less&scoped=true"

import exportComponent from "/Users/cain/Workspaces/projects/roar/roar-fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc458fac"]])

export default __exports__